import { P2GBox } from '@parcel2go/core-ui';
import { P2GDropdown } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';

import { SvgParcelLabel } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { Fragment, ReactNode, useMemo, useState } from 'react';
import { GenerateNumbers } from '../../../lib/helpers/ArrayHelper';
import P2GContentDropDown from '../../P2GContentDropDown';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';

interface props {
  options: number;
  selected: number;
  onClick: (q: number) => void;
  groupingControl: ReactNode;
  children: ReactNode;
}

export const SplitWithDropDown: React.FC<props> = (props) => {
  const maxParcels = 12;
  const cutOff = 10;
  const parcelsPerRow = 5;

  const [showMore, setShowMore] = useState(props.selected > cutOff);
  const options = useMemo(() => {
    if (props.options == 0) {
      return [];
    }
    if (props.options == 1 || props.options > maxParcels) {
      return GenerateNumbers(1, maxParcels);
    }
    return GenerateNumbers(1, props.options);
  }, [props.options]);

  if (options.length <= 1) {
    return <P2GLinkGroup pt={1} links={[props.groupingControl as any]} />;
  }

  return (
    <P2GLinkGroup
      pt={1}
      links={[
        <P2GContentDropDown control={props.children} key={props.selected}>
          <div style={{ width: '300px' }}>
            <P2GBox textAlign="center" p={1}>
              <P2GGrid container alignItems="baseline" justify="center">
                {options.slice(0, cutOff).map((o) => (
                  <Fragment key={o}>
                    <P2GGrid item>
                      <P2GBox p={1} onClick={() => props.onClick(o)} textAlign="center">
                        <div
                          style={{ opacity: o == props.selected ? 1 : 0.3 }}
                          title={o == 1 ? '1 Parcel' : `${o} Parcels`}
                        >
                          <CdnIconProxy
                            src="/theme/icons/ParcelLabel.svg"
                            size={o == props.selected ? 'md' : 'sm'}
                            palette="primary"
                          >
                            <SvgParcelLabel />
                          </CdnIconProxy>
                        </div>
                        <P2GText small colour="primary">
                          <strong>{o}x</strong>
                        </P2GText>
                      </P2GBox>
                    </P2GGrid>
                    {o % parcelsPerRow == 0 && <P2GGrid item xs={12} />}
                  </Fragment>
                ))}
              </P2GGrid>
              {options.length > cutOff && (
                <P2GBox pl={3} pr={3} pt={1} pb={1}>
                  {showMore ? (
                    <P2GDropdown
                      fullWidth={false}
                      options={options.slice(cutOff).map((o) => {
                        return { value: o.toString() };
                      })}
                      value={`${props.selected}`}
                      id="Parcel Options"
                      onChange={(x) => props.onClick(Number(x))}
                    />
                  ) : (
                    <P2GLink onClick={() => setShowMore(true)}>Show more</P2GLink>
                  )}
                </P2GBox>
              )}
              <P2GBox mt={1}>
                <P2GText variant="body2">How many parcels will you will be sending?</P2GText>
              </P2GBox>
            </P2GBox>
          </div>
        </P2GContentDropDown>,
        props.groupingControl as any
      ]}
    />
  );
};
